module.exports = [{"text":"Home","value":"Home"},{"text":"Work","value":"Work"},{"text":"Public Chargers","value":"Public Chargers"}]


//////////////////
// WEBPACK FOOTER
// ./src/fixtures/locations.json
// module id = 815
// module chunks = 0